import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="components--modal"
export default class extends Controller {
  connect() {
    if (window.$) {
      this.previouslyFocusedElement = document.activeElement;
      window.$(this.element).on('hide.bs.modal', () => this.restoreFocus());
      window.$(this.element).modal('show');
      window.$(this.element).on('hidden.bs.modal', () => this.hideModal());
    }
  }

  restoreFocus() {
    const focusedElement = document.activeElement;

    if (!this.element.contains(focusedElement)) return;

    if (
      this.previouslyFocusedElement &&
      document.contains(this.previouslyFocusedElement)
    ) {
      this.previouslyFocusedElement.focus();
    } else {
      focusedElement.blur();
    }
  }

  hideModal() {
    const turboFrame = this.element.closest('turbo-frame');

    if (turboFrame) {
      turboFrame.innerHTML = '';
    } else {
      this.element.remove();
    }
  }
}
